import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../UrlHelper/baseUrl";

const PaymentStatus = () => {
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("Checking payment...");
  const navigate = useNavigate();

  useEffect(() => {
    const checkStatus = async () => {
      try {
        const accessToken = localStorage.getItem("accessToken");
        const merchantOrderId = localStorage.getItem("merchantOrderId");

        if (!accessToken || !merchantOrderId) {
          setMessage("Invalid session. Please try again.");
          return navigate("/cart");
        }

        const res = await axios.post(`${baseUrl}/checkOrderStatus`, {
          accessToken,
          merchantOrderId,
        });

        console.log("✅ Payment Status Response:", res.data);
        console.log("res.data.state:", res.data.state);
        console.log(`res.data.state === "COMPLETED"`, res.data.state === "COMPLETED");
        if (res.data.state === "COMPLETED") {
          setMessage("Payment Successful ✅");
          setTimeout(() => navigate("/thank-you"), 2000);
        } else {
          setTimeout(() => navigate("/"), 2000);
        }
      } catch (err) {
        setMessage("Error checking payment.");
        setTimeout(() => navigate("/"), 2000);
      } finally {
        setLoading(false);
      }
    };

    checkStatus();
  }, [navigate]);

  return (
    <div className="container text-center" style={{ marginTop: "100px" }}>
      <h2>{loading ? "Processing..." : message}</h2>
    </div>
  );
};

export default PaymentStatus;
